export enum ProductImageFormatType {
  ThumbnailMedium = 1,
  ThumbnailSmall = 2,
}

(ProductImageFormatType as any).__typeName = 'ProductImageFormatType';
